export const COLORS = [
  '#25274D',
  '#67C8FA',
  '#4D506D',
  '#71A1C0',
  '#9D2872',
  '#00D8DD',
  '#9076FF',
]
